import React from "react";
import { CookiesProvider } from "react-cookie";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./App";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import "./styles/sanitize.css";
import { reagentFetcher } from "./fetch/SearchRequest";
import { installApiClient } from "./fetch/apiClient";
import ToastContainer from "./toast/ToastContainer";
import { ConfirmProvider } from "./confirm/ConfirmProvider";

// 認証ヘッダー付与・401処理のため、最初に fetch ラッパーを有効化する
installApiClient();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <CookiesProvider>
        <ConfirmProvider>
          <AppRoutes />
          <ToastContainer />
        </ConfirmProvider>
      </CookiesProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
